import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbGoodToGoBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`good-to-go ${props.attributes.className ? props.attributes.className : ''} ${classes.goodToGo} ${classes.goodToGoTheme} ${props.attributes.alertBgClass}`}>
        {blocks.map((block) => {
            return block;
        })}
    </div>
};

export const CgbGoodToGoBlockFragment = graphql`
  fragment CgbGoodToGoBlock on WpBlock {
    ... on WpCgbGoodToGoBlock {
        name
        attributes {
            className
            alertBg
            alertBgClass
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbGoodToGoBlockPreview = `
    ... on CgbGoodToGoBlock {
        name
        attributes {
            className
            alertBg
            alertBgClass
        }
    }
`;